import { responseToCountKey } from 'app/events/helpers/event-response-helpers';
import { CalendarEventResponseStatusEnum } from 'generated/graphql';
import { isNilOrEmpty } from 'helpers';
import { cloneDeep } from 'lodash-es';
import { removeEmptyRuleSets } from 'query-builder/core/remove-empty-rulesets';
import { getDefaultTagsAdvancedRule } from 'query-builder/core/simple-query-default-ruleset';
import { Rule, RuleSet } from 'query-builder/query.interfaces';
import {
  ICalendarEventResponseFieldValueViewModel,
  ICalendarEventResponseSubqueryQueryField
} from '../components/calendar-event-response-subquery-input/CalendarEventResponseFieldViewModel';

export class CalendarEventResponseSubqueryHelpers {
  /**
   * Takes a 'calendar_event_response_subquery' rule
   * and converts it a "simple" format for the
   * simple query builder.
   *
   * @param rule 'calendar_event_response_subquery' rule
   */
  static toSimpleCalendarEventResponseUIValue(ruleValue: ICalendarEventResponseSubqueryQueryField['value']):
    ICalendarEventResponseFieldValueViewModel {
    const tagsComboRuleSet = CalendarEventResponseSubqueryHelpers.extractAdvancedTagRuleSet(ruleValue);
    const result = {
      createdBy: ruleValue.created_by,
      calendarEventIds: ruleValue.calendar_event_ids,
      rsvpStatuses: ruleValue.rsvp_statuses,
      minCalendarEventResponses: ruleValue.min_calendar_event_responses,
      maxCalendarEventResponses: ruleValue.max_calendar_event_responses,
      tagsComboRuleSet,
    };

    return cloneDeep(result);
  }

  /**
   * Converts the subquery VM to a complex rule
   *
   * @param viewModel
   */
  static toComplexCalendarEventResponseRuleFormValue(viewModel: ICalendarEventResponseFieldValueViewModel):
    ICalendarEventResponseSubqueryQueryField['value'] {
    const hasTagAdvancedRule = !isNilOrEmpty(viewModel.tagsComboRuleSet);
    const subqueryRules = [];

    if (hasTagAdvancedRule) {
      subqueryRules.push(viewModel.tagsComboRuleSet);
    }

    const subquery = removeEmptyRuleSets({
      condition: 'and',
      rules: subqueryRules
    });

    const result: ICalendarEventResponseSubqueryQueryField['value'] = {
      created_by: viewModel.createdBy,
      rsvp_after_date: viewModel.rsvpAfterDate,
      rsvp_before_date: viewModel.rsvpBeforeDate,
      calendar_event_ids: viewModel.calendarEventIds,
      rsvp_statuses: viewModel.rsvpStatuses,
      min_calendar_event_responses: viewModel.minCalendarEventResponses,
      max_calendar_event_responses: viewModel.maxCalendarEventResponses,
      subquery: subquery as any
    };

    return result;
  }

  static extractAdvancedTagRuleSet(calendarEventResponseFieldRuleValue: ICalendarEventResponseSubqueryQueryField['value']): RuleSet {
    const subquery: RuleSet = calendarEventResponseFieldRuleValue?.subquery;
    const subqueryRules = subquery?.rules;

    const defaultRuleset = {
      condition: 'and',
      ui_condition_field: 'tags_combo',
      rules: [
        getDefaultTagsAdvancedRule('calendar_event_response', 'include having any'),
        getDefaultTagsAdvancedRule('calendar_event_response', 'exclude having any'),
      ]
    };

    const tagAdvancedRuleSet = (subqueryRules || [])
      .find((r: Rule | RuleSet) => r['ui_condition_field'] === 'tags_combo' || r['condition']) as RuleSet;

    if (!tagAdvancedRuleSet) {
    } else {
      tagAdvancedRuleSet.ui_condition_field = 'tags_combo';
    }
    return tagAdvancedRuleSet || defaultRuleset;
  }

  static createEventResponseQuery(eventIds: string[], responses: CalendarEventResponseStatusEnum[]): RuleSet {
    return {
      condition: 'and',
      rules: [
        {
          field: 'calendar_event_response_subquery',
          operator: 'include',
          value: {
            created_by: [],
            calendar_event_ids: eventIds,
            rsvp_statuses: responses,
          }
        },
      ]
    };
  }
}
